<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option"
            :width="width" :extendData="extendData"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "BarChart",
  components: {Chart},
  props: {
    data : null,
    extendData: null,
  },
  data() {
    return {
      id: "BarChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  methods: {
    getOption: function () {
      const tag = this.data.tag;
      const normalCount = this.data.normal;
      const exception = this.data.exception;
      const online = this.data.online;
      const offline = this.data.offline;
      const borderData = [];
      const legend = this.data.statusName;
      const colorArr = [
        {
          start: "rgba(95, 227, 161,",
          end: "rgba(255, 255, 255,0.5)"
        }, {
          start: "rgba(255, 131, 115,",
          end: "rgba(255, 255, 255,0.5)"
        },
        {
          start: "rgba(0, 152, 255,",
          end: "rgba(255, 255, 255,0.5)"
        },
        {
          start: "rgba(254, 193, 99,",
          end: "rgba(255, 255, 255,0.5)"
        }
      ];
      const normalColor = "rgba(73, 164, 243, .2)";
      const textColor = "#eee";
      const seriesData = [];
      const borderHeight = 0.2;
      for (let i = 0; i < tag.length; i++) {
        borderData.push(borderHeight);
      }
      for (let i = 0; i < 4; i++) {
        let data = null;
        if (i === 0){
          data = normalCount;
        }else if(i === 1){
          data = exception;
        }else if(i === 2){
          data = online;
        }else{
          data = offline;
        }
        var obj1 = {};
        obj1 = {
          name: legend[i],
          type: "bar",
          stack: legend[i],
          data: data,
          barWidth: "15%",
          itemStyle: {
            normal: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 1,
                  color:  colorArr[i].start + "1)"
                },
                  {
                    offset: 0.5,
                    color: colorArr[i].start + "0.8)"
                  },
                  {
                    offset: 0,
                    color: colorArr[i].start + "0.5)"
                  }
                ],
                globalCoord: false
              }
            }
          }
        };
        seriesData.push(obj1);
      }
      this.option = {
        grid: {
          left: "5%",
          top: "12%",
          right: "5%",
          bottom: 0,
          containLabel: true
        },
        legend: {
          show: true,
          icon: "rect",
          right: "6%",
          top: "0%",
          textStyle: {
            color: textColor
          },
          data: legend
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var str = "";
            for (var i = 0; i < params.length; i++) {
              if (params[i].seriesName !== "") {
                str +=
                    params[i].name +
                    ":" +
                    params[i].seriesName +
                    params[i].value +
                    "<br/>";
              }
            }
            return str;
          }
        },
        xAxis: [{
          type: "category",
          data: tag,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            textStyle: {
              color: textColor,
              fontSize: 12
            },
            padding:[0,18,0,0]
          },
          axisLine: {
            lineStyle: {
              color: normalColor
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        yAxis: [{
          type: "value",
          name: "",
          nameTextStyle: {
            color: normalColor,
            fontSize: 12
          },
          axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: textColor,
              fontSize: 12
            }
          },
          axisLine: {
            lineStyle: {
              color: normalColor
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: normalColor
            }
          }
        }],
        series: seriesData
      };
    },
  },
}
</script>

<style scoped>

</style>
